<div class="create_your_account_section">
  <div class="page_width_lp">
    <h2>{{ 'landing.start-today' | translate }}</h2>
    <a routerLink="/auth/rest-signup">{{ 'landing.start-today-link' | translate }} <i class="bi bi-arrow-right"></i></a>
    <div class="button_center">
      <img src="/../assets/img/landing-page/admin-screenshot.jpg" alt="Administration EAT'Z">
    </div>
  </div>
</div>
